import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import Formation from "../components/Formation";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}

        {/* Breadcrumb */}
        <Breadcrumb title="Formation" />

        {/* UsersListLayer */}
        <Formation />


    </>
  );
};

export default UsersListPage; 
